<template>
    <v-cascader
        v-if="ruleOptions.length"
        :value="selectorValue"
        :options="ruleOptions"
        @input="onChangeComponent"
    >
        <template
            slot="item"
            slot-scope="props"
        >
            <div class="select-inner">
                <v-tip
                    v-if="props.item.tip"
                    ref="tip"
                    kind="large"
                    placement="top"
                    :style="props.item.tip.style"
                >
                    <div :style="props.item.tip.style">
                        {{ props.item.tip.text }}
                    </div>
                </v-tip>
                <div>
                    <span>{{ props.item.text }}
                        <v-icon
                            v-if="props.item.tip"
                            v-tip:tip
                            class="rule__name__tip"
                            name="v-error"
                        /></span>
                </div>
            </div>
        </template>
        <template
            slot="header"
            slot-scope="props"
        >
            <div>
                <div>
                    <span>{{ headerText(props.item) }}</span>
                </div>
            </div>
        </template>
    </v-cascader>
</template>

<script>
export default {
  name: 'RuleSelector',

  props: {
    value: {
      type: String,
      default: '',
    },
    // 下拉树定义，如果是字符串则展示一个没有下拉只有名字的面板
    ruleOptions: {
      type: [Array, String],
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      currentValue: this.value,
    };
  },

  computed: {
    selectorValue() {
      return this.convertValueToSelectorValue(this.value, this.ruleOptions);
    },
  },

  methods: {
    onChangeComponent(value) {
      const result = this.getItemInfo(value[[value.length - 1]], this.ruleOptions);
      this.$emit('change-component', result);
    },

    headerText(item) {
      let result = '';
      if (item && item.length) {
        result = this.$t(item[item.length - 1].text);
      }
      return result;
    },

    // 因为多级菜单返回的是结果的族谱，但是输出的时候只需要最小子孙，这里将最小祖孙转化为族谱，来做多级菜单的入参
    convertValueToSelectorValue(value, list) {
      let result = [];
      for (let i = 0, len = list.length; i < len; i += 1) {
        const item = list[i];
        if (item.children && item.children.length) {
          const convertResult = this.convertValueToSelectorValue(value, item.children);
          if (convertResult.length) {
            convertResult.unshift(item.value);
            result = convertResult;
            break;
          }
        } else if (item.value === value) {
          result = result.concat(value);
          break;
        }
      }
      return result;
    },
    // 通过元素id获得元素详情
    getItemInfo(value, list) {
      let result = {};
      for (let i = 0, len = list.length; i < len; i += 1) {
        const item = list[i];
        if (item.children && item.children.length) {
          const convertResult = this.getItemInfo(value, item.children);
          if (convertResult.value) {
            result = convertResult;
            break;
          }
        } else if (item.value === value) {
          result = item;
          break;
        }
      }
      return result;
    },
  },
};
</script>
<style lang="less">
@import '~src/common/common.less';
.rule-item__title {
    .v-cascader__trigger {
        min-width: 0;
    }
}
.rule-group__add-item {
  .v-cascader__trigger {
      height: 24px;
    }
}

.rule__name__tip {
    width: 15px;
    color: @mainLightGray;
    vertical-align: -5px;
}
</style>
